import React from "react";
import { SortableIcon, SortedIcon } from "../Cells/SortableHeader";
import { jsx as _jsx } from "react/jsx-runtime";
export default {
  iconDefault: /*#__PURE__*/_jsx(SortableIcon, {}),
  iconUp: /*#__PURE__*/_jsx(SortedIcon, {
    sortBy: "ascending"
  }),
  iconDown: /*#__PURE__*/_jsx(SortedIcon, {
    sortBy: "descending"
  })
};